'use client';

import { c as _c } from "react/compiler-runtime";
import useJourneyData from '~/hooks/useJourneyData';
import { useSaveTripPrompt } from './useSaveTripPrompt';
export function SaveTripPrompt() {
  const $ = _c(5);
  const {
    uniqueId,
    title,
    details
  } = useJourneyData();
  const t0 = details?.startDate;
  const t1 = details?.endDate;
  let t2;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== title || $[3] !== uniqueId) {
    t2 = {
      tripId: uniqueId,
      tripTitle: title,
      startDate: t0,
      endDate: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = title;
    $[3] = uniqueId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useSaveTripPrompt(t2);
  return null;
}